/**
 * Subsample Encryption
 *
 * @group ISOBMFF
 *
 * @beta
 */
export type SubsampleEncryption = {
	bytesOfClearData: number;
	bytesOfProtectedData: number;
};
